module.exports = __webpack_public_path__ + "static/img/department1.05fb72a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/home/department1.png
// module id = ypT1
// module chunks = 1